import './App.css';
import '../src/Components/Style/Style.css'
import AdminLogin from './Components/Auth/AdminLogin';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import { Routes, Route, Navigate } from 'react-router-dom';
import Navb from './Components/Header/Navb';
import { useDispatch, useSelector } from 'react-redux';
import ForgetPwd from './Components/Auth/ForgetPwd';
import Popup from './Components/CommonPopup/Popup';
import ResetPwd from './Components/Auth/Resetpwd';
import { checkToken } from './Components/Redux/Dashboard/DashboardSlice';
import { useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import Sidebar from './Components/Dashboard/Sidebar';
import Home from './Components/Dashboard/Home';
import Editprofile from './Components/Dashboard/Editprofile';
import CreateCourse from './Components/Dashboard/CreateCourse';
import StudentsList from './Components/Dashboard/StudentsLists';
import DashboardPopUp from './Components/CommonPopup/DashboardPopUp';
import ShowAllCourses from './Components/Dashboard/ShowAllCourses';
import CreateCourseDialog from './Components/Dashboard/CreateCourseDialog';
import EditCourse from './Components/Dashboard/EditCourse';
import TransactionsList from './Components/Dashboard/TransactionsList';
import TransactionsDetailsDialog from './Components/Dashboard/TransactionsDetailsDialog';
import AddStudents from './Components/Dashboard/AddStudents';
import EnquiryList from './Components/Dashboard/EnquiryList';
import EnquiryViewDetails from './Components/Dashboard/EnquiryViewDetails';
import AllCoursesShowing from './Components/Dashboard/AllCoursesShowing';
import ChapterDataShow from './Components/Dashboard/ChaptersDataShow';
import AllCoursesVideos from './Components/Dashboard/AllCoursesVideos';
import AllCoursesDetails from './Components/Dashboard/AllCoursesDetails';
import Notification from './Components/Dashboard/Notification';
import LiveSessionPage from './Components/Dashboard/LiveSessionPage';
import HideCourses from './Components/Dashboard/HideCourses';
import BulkActionDialog from './Components/Dashboard/BulkStudentsAction/BulkActionDialog';
import BulkCoursesDialog from './Components/Dashboard/BulkStudentsAction/BulkCoursesDialog';

function App() {
  const dispatch = useDispatch()

  const selector = useSelector((s) => s.AuthSlice)
  const Dashselector = useSelector((s) => s.DashboardSlice)
  const dashShow = Dashselector.dashShow
  const showDashPopup=Dashselector.showDashPopup
  const showCreateCourseDialog = Dashselector.showCreateCourseDialog
  const showCreateNewCourseDialog= Dashselector.showCreateNewCourseDialog
  const showEditCourseDialog = Dashselector.showEditCourseDialog;
  const openshowTransactionDialog = Dashselector.openshowTransactionDialog;
  const showAddStudentDialog = Dashselector.showAddStudentDialog;
  const openEnquiryDialog = Dashselector.openEnquiryDialog;
  const showBulkActionDialog = Dashselector.showBulkActionDialog;
  const showBulkCoursesDialog = Dashselector.showBulkCoursesDialog?.open;

  const showPopup = selector.showPopup

  const token = localStorage.getItem("token")

  // ✅ Token & Branch Expiry Check (1h = 3600s)
  const isTokenValid = () => {
    if (!token) return false;
    try {
      const decoded = jwtDecode(token);
      const now = Date.now() / 1000; // Convert milliseconds to seconds
      return decoded.exp > now;
    } catch {
      return false;
    }
  };

  const isAuthenticated = isTokenValid();

  useEffect(() => {
    if (token) {
      dispatch(checkToken(true))

    } else {
      dispatch(checkToken(false))
    }
  }, [token])
  return (
    <div className="App">
      {token && isAuthenticated ? <Navb /> : ""}

      {dashShow && <Sidebar />}
      {showPopup && <Popup />}
      {/* {showDashPopup && <DashboardPopUp/> } */}
      {showCreateCourseDialog && <CreateCourseDialog/> }
      {showCreateNewCourseDialog && <CreateCourse />}
      {showEditCourseDialog && <EditCourse />}
      {openshowTransactionDialog && <TransactionsDetailsDialog/>}
      {showAddStudentDialog && <AddStudents/>}
      {openEnquiryDialog && <EnquiryViewDetails/>}
      {showBulkActionDialog && <BulkActionDialog/>}
      {showBulkCoursesDialog && <BulkCoursesDialog/>}
      <Routes>
        <Route path='/' element={isAuthenticated ? <Navigate to="/home" /> : <AdminLogin />} />
        <Route path='/home' element={isAuthenticated ? <Home /> : <Navigate to="/" />} />
        <Route path='/forgetpwd' element={<ForgetPwd />} />
        <Route path='/resetpwd/:token' element={isAuthenticated ?<ResetPwd />: <Navigate to="/" />} />
        <Route path='/profile' element={isAuthenticated ?<Editprofile />: <Navigate to="/" />} /> 
        <Route path='/allCourses' element={isAuthenticated ?<ShowAllCourses />: <Navigate to="/" />} /> 
        <Route path='/notification' element={isAuthenticated ?<Notification />: <Navigate to="/" />} /> 
        <Route path='/allVideos' element={isAuthenticated ?<AllCoursesVideos />: <Navigate to="/" />} /> 
        <Route path='/allVideosDetails' element={isAuthenticated ?<AllCoursesDetails />: <Navigate to="/" />} /> 
        <Route path='/courses' element={isAuthenticated ?<AllCoursesShowing />: <Navigate to="/" />} /> 
        <Route path='/live-session' element={isAuthenticated ?<LiveSessionPage />: <Navigate to="/" />} />
        <Route path='/studentsList' element={isAuthenticated ?<StudentsList />: <Navigate to="/" />} /> 
        <Route path='/transaction' element={isAuthenticated ?<TransactionsList />: <Navigate to="/" />} /> 
        <Route path='/enquiry' element={isAuthenticated ?<EnquiryList />: <Navigate to="/" />} /> 
        <Route path='/HideCourses' element={isAuthenticated ?<HideCourses />: <Navigate to="/" />} /> 
        <Route path='*' element={<Navigate to="/" />} />
      </Routes>

    </div>
  );
}

export default App;

